
export function toMap<T>(list: T[], keyField: string): { [key: string]: T } {
  const map: { [key: string]: T } = {};
  for (const i of list) {
    map[(i as any)[keyField]] = i;
  }
  return map;
}
